<template>
  <div class="banner">
    <!-- <el-carousel indicator-position="none" :autoplay="false">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <img
          :ref="'img' + index" :id="'id'+index"
          :class="'banImg' + index"
          :src="item.url"
          alt=""
        />
      </el-carousel-item>
    </el-carousel> -->
    <swiper v-if="bannerList.length" class="banner1" :options="swiperOption1" ref="mySwiper1">
      <swiper-slide v-for="(item, index) in bannerList" :key="index">
        <img :src="item.url" alt="" />
      </swiper-slide>
      <!-- <div class="swiper-pagination" slot="pagination"></div> -->
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      bannerList: [],
      swiperOption1: {
        loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
      },
    };
  },
  mounted() {
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      window.location.href = "http://demo.daru.xin/web/phone";
      // console.log("移动端");
    } else {
      //pc端
    }

    this.getBannerList();
  },
  methods: {
    getBannerList() {
      this.$get("/web/api/list_lun_bo").then((res) => {
        if (res.code == 200) {
          this.bannerList = res.data;
       
        }
      });
    },
  },
};
</script>

<style  scoped>
.banner {
  display: block;
}
.banner img {
  display: block;
  width: 100%;
  /* height: 535px; */
  /* object-fit: cover ; */
}
.banner1 {
  width: 100%;
  /* height:535px; */
}
</style>